import { Drawer, useOverlayState } from "@heroui/react";
import CreateMeetsDesktop from "../create-meets/create-meets-desktop-comp";

const CreateMeetsDrawer = ({ show, onResp, initialValues }) => {
  const state = useOverlayState({
    isOpen: show,
    onOpenChange: (isOpen) => {
      if (!isOpen) onResp?.("close", null);
    },
  });

  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur">
        <Drawer.Content placement="right">
          <Drawer.Dialog className="h-full md:w-[min(880px,96vw)] overflow-hidden p-0">
            <CreateMeetsDesktop
              key={initialValues ? `${initialValues.date}-${initialValues.startTime}` : "default"}
              initialValues={initialValues}
              onCancel={() => state.close()}
              _onResp={(cmd, data) => {
                if (cmd === "success") {
                  state.close();
                  onResp?.("success", data);
                }
              }}
            />
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default CreateMeetsDrawer;